<template>
  <div>
    <a-drawer
      title="上传SQL文件"
      placement="right"
      width="500"
      :closable="false"
      @close="onClose"
      :visible="visible"
    >
      <a-form :form="form" @submit="saveColumnData">
        <a-form-item
          label="SQL文件名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'name'
            ]"
            placeholder="留空系统将自动生成名称"/>
        </a-form-item>
        <a-form-item
          :required="true"
          label="SQL文件"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-upload
            name="file"
            action="/admin.php/upload_file/uploadFile?type=sqlfile&local=YES"
            @change="handleChange"
          >
            <a-button> <a-icon type="upload" /> 点击上传 </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item
          label="文件类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'sql_type',
              {
                initialValue: addData.sql_type,
                rules: [{ required: true, message: '请选择' }]
              }
            ]"
            placeholder="请选择类型">
            <!-- <a-select-option value="DATABASE">初始数据库</a-select-option> -->
            <a-select-option value="PATCH">数据库补丁</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            v-decorator="[
              'remark',
              {
                rules: [{ required: true, message: '请输入备注' }]
              }
            ]"
            :rows="6"
            placeholder="请输入备注"/>
        </a-form-item>
        <a-form-item :wrapperCol="{span: 12, offset: 9}">
          <a-button style="margin-right:20px" html-type="submit" type="primary" :loading="loading">创建</a-button>
          <a-button @click="onClose">取消</a-button>
        </a-form-item>
      </a-form>
    </a-drawer>
  </div>
</template>
<script>
import { addSql } from '@/api/sql'
import _ from 'lodash'
export default {
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created () {
    // this.handelPre()
  },
  data () {
    return {
      form: this.$form.createForm(this),
      // 编辑抽屉弹窗form-item标题样式
      labelCol: { lg: { span: 6 }, sm: { span: 5 } },
      // 编辑抽屉弹窗form-item组件样式
      wrapperCol: { lg: { span: 15 }, sm: { span: 19 } },
      // 按钮加载
      loading: false,
      // 添加数据
      addData: {
        name: '',
        sql_path: '',
        sql_type: 'PATCH',
        remark: ''
      },
      fileList: [],
      logoUrl: ''
    }
  },
  methods: {
    // handelPre () {
    //   pre().then(res => {
    //     if (_.get(res, 'code') === 200) {
    //     }
    //   })
    // },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.addData[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} SQL文件上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        // const fileUrl = _.get(info.file, 'response.data.url')
        this.addData[targetId] = path
        this.$message.success(`${info.file.name} SQL文件上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} SQL文件上传失败`)
      }
    },
    handleChange (info) {
      this.handleFileUpload(info, 'sql_path')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    // 抽屉关闭事件
    onClose () {
      this.$emit('hide')
    },
    // 抽屉保存按钮
    saveColumnData (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          this.addData.name = fieldsValue['name']
          this.addData.sql_type = fieldsValue['sql_type']
          this.addData.remark = fieldsValue['remark']
          addSql(this.addData).then(res => {
            if (_.get(res, 'code') === 200) {
              this.loading = false
              this.$message.success('SQL文件保存成功')
              setTimeout(() => { this.$emit('finish') }, '500')
            } else this.loading = false
          })
        } else this.loading = false
      })
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  }
}
</script>
